import { createContext, useContext, useEffect, useState } from "react";

const InstallContext = createContext(null);

export const InstallProvider = ({ children }) => {
    const [installEvent, setInstallEvent] = useState(null);

    useEffect(() => {
        const handler = (e) => {
            console.log("📦 EVENTO beforeinstallprompt capturado globalmente");
            e.preventDefault();
            setInstallEvent(e);
        };

        window.addEventListener("beforeinstallprompt", handler);
        return () => window.removeEventListener("beforeinstallprompt", handler);
    }, []);

    return (
        <InstallContext.Provider value={installEvent}>
            {children}
        </InstallContext.Provider>
    );
};

export const useInstallPrompt = () => useContext(InstallContext);